import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * Directive to add 'click outside' functionality to any element
 * 
 * The directive detects clicks anywhere on the page that isn't on the element the directive 
 * is attached to and emits an event.
 * 
 * An example below is for a button that opens an Actions Drawer, but when you click elsewhere on the page,
 * the drawer will be hidden.
 * ```html
 * <div (click-outside)="hideDrawer()">
 * 	<button (click)="showDrawer()">Show Drawer</button>
 * 	<div *ngIf="showActions">
 * 		<!-- Action Drawer Content -->
 * 	</div>
 * </div>
 * ```
 */
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[click-outside]'
})
export class ClickOutsideDirective {

	@Output('click-outside') public clickOutsideEvent: EventEmitter<any> = new EventEmitter<any>();

	private clickInside: boolean = false;

	@HostListener('click')
	public onElementClick(): void {
		this.clickInside = true;
	}

	@HostListener('document:click')
	public onDocumentClick(): void {
		if (!this.clickInside) {
			this.clickOutsideEvent.emit();
		}
		this.clickInside = false;
	}

}
